module.exports = __webpack_public_path__ + "img/Group 126@2x.dd129223.png";